import { handleActions } from 'redux-actions';

import { deepFreeze } from '@mw/helpers';

import { ChatbotOrigins } from '~/constants';
import { resetUserData, setUserData } from '~/actions/user';
import { LocalStorage } from '~/helpers';

const initialState = deepFreeze({
  config: {
    chatbot_settings: {
      [ChatbotOrigins.OWN]: { is_enabled: false },
      [ChatbotOrigins.CHATBOT_COM]: { is_enabled: false, access_token: '' },
      [ChatbotOrigins.DIALOGFLOW]: { is_enabled: false, credentials: null },
    },
    notification_settings: {},
    short_links_enabled: false,
  },
  info: { email: '' },
  isPooling: false, // request gets triggered on initial load of company info
  isConnected: false, // shows that Izonet account is connected to the MW user
  isVerified: false, // shows that user was manually verified (by MW admin)
  balance: 0,
  unlimitedTopUp: false, // shows that user is able to top up account from configured value,

  isAuthorized: false,
});

export const user = handleActions(
  {
    [setUserData]: (state, { payload: userData }) => {
      const newState = {
        ...state,
        ...userData,
      };

      LocalStorage.setUser(newState);

      return newState;
    },
    [resetUserData]: () => ({
      ...initialState,
    }),
  },
  initialState
);
